import { SupportedLocales } from '@/models/localization.model';
import { IPhotosOrder, ICreateProductMainInfoDTO } from '@/models/products.model';
import {
  getNewAddedFiles,
  getNewAddedFilesIds,
  getProductPhotosOrdersList,
  TCreateProductFormValues,
  CreateProductFormFieldsNames,
  MeasureUnitCode,
} from '../helpers';

class CreateNewProductDTO implements ICreateProductMainInfoDTO {
  locale: { [key in SupportedLocales]: { name: string; description: string; original_name?: string | null } };
  slug?: string;
  external_id?: string;
  uktzed?: string;
  imported?: '0' | '1';
  is_custom_order?: '0' | '1';
  weight?: number;
  length?: number;
  height?: number;
  width?: number;
  photos?: File[];
  photo_ids?: string[];
  order: IPhotosOrder[];
  store_id: string;
  unit_code?: MeasureUnitCode;
  package_quantity?: number;
  min_order_packages?: number;

  constructor(values: TCreateProductFormValues) {
    this.store_id = values[CreateProductFormFieldsNames.STORE_ID];
    this.slug = values[CreateProductFormFieldsNames.SLUG];
    this.external_id = values[CreateProductFormFieldsNames.EXTERNAL_ID];
    this.locale = values[CreateProductFormFieldsNames.LOCALE];

    this.uktzed = values[CreateProductFormFieldsNames.UKTZED];
    this.imported = !!values[CreateProductFormFieldsNames.IMPORTED] ? '1' : '0';
    this.is_custom_order = !!values[CreateProductFormFieldsNames.IS_CUSTOM_ORDER] ? '1' : '0';
    this.weight = values[CreateProductFormFieldsNames.WEIGHT];
    this.length = values[CreateProductFormFieldsNames.LENGTH];
    this.height = values[CreateProductFormFieldsNames.HEIGHT];
    this.width = values[CreateProductFormFieldsNames.WIDTH];
    this.photos = getNewAddedFiles(values[CreateProductFormFieldsNames.PHOTOS]);
    this.photo_ids = getNewAddedFilesIds(values[CreateProductFormFieldsNames.PHOTOS]);
    this.order = getProductPhotosOrdersList(values[CreateProductFormFieldsNames.PHOTOS]);
    this.unit_code = values[CreateProductFormFieldsNames.UNIT_CODE];
    this.package_quantity = values[CreateProductFormFieldsNames.PACKAGE_QUANTITY];
    this.min_order_packages = values[CreateProductFormFieldsNames.MIN_ORDER_PACKAGES];
  }
}

export default CreateNewProductDTO;
